import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface PageSEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown>;
}

export default function PageSEO({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  schema,
}: PageSEOProps) {
  const location = useLocation();
  const fullTitle = `${title} | 年轻的朋友韩国`;
  const baseUrl = 'https://starhallyu.github.io';
  const canonical = canonicalUrl ? `${baseUrl}${canonicalUrl}` : `${baseUrl}${location.pathname}`;

  useEffect(() => {
    document.title = fullTitle;

    const setMeta = (name: string, content: string, property = false) => {
      let el: HTMLMetaElement | null;
      if (property) {
        el = document.querySelector(`meta[property="${name}"]`);
      } else {
        el = document.querySelector(`meta[name="${name}"]`);
      }
      if (!el) {
        el = document.createElement('meta');
        if (property) {
          el.setAttribute('property', name);
        } else {
          el.setAttribute('name', name);
        }
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);

    const linkEl = document.querySelector('link[rel="canonical"]');
    if (linkEl) {
      linkEl.setAttribute('href', canonical);
    }

    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonical, true);
    if (ogImage) setMeta('og:image', ogImage, true);

    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);
    if (ogImage) setMeta('twitter:image', ogImage);
  }, [fullTitle, description, keywords, canonical, ogType, ogImage]);

  return (
    <>
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </>
  );
}